import { render } from "./wf-qxc.vue?vue&type=template&id=b4e21ade&scoped=true"
import script from "./wf-qxc.vue?vue&type=script&lang=js"
export * from "./wf-qxc.vue?vue&type=script&lang=js"

import "./wf-qxc.vue?vue&type=style&index=0&id=b4e21ade&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e21ade"]])

export default __exports__